import {PayoutInstructionStatus} from '@sollapay/enums';
import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type PayoutInstructionStatusToastProps = {
  toastId: string | number;
  status:
    | PayoutInstructionStatus.APPROVED
    | PayoutInstructionStatus.FAILED
    | PayoutInstructionStatus.CANCELLED;
  amount: string;
  onNavigate: () => void;
};

const STATUS_KEY: Record<PayoutInstructionStatusToastProps['status'], string> = {
  [PayoutInstructionStatus.APPROVED]: 'approved',
  [PayoutInstructionStatus.FAILED]: 'failed',
  [PayoutInstructionStatus.CANCELLED]: 'cancelled'
};

export const PayoutInstructionStatusToast: FC<PayoutInstructionStatusToastProps> = ({
  toastId,
  status,
  amount,
  onNavigate
}) => {
  const {t} = useTranslation('payments');
  const key = STATUS_KEY[status];
  const isError =
    status === PayoutInstructionStatus.FAILED || status === PayoutInstructionStatus.CANCELLED;

  return (
    <ToastCard
      iconName={isError ? 'sollapay:close' : 'sollapay:check'}
      title={t(`payoutInstructionStatusToast.${key}.title`)}
      description={t(`payoutInstructionStatusToast.${key}.description`, {amount})}
      action={{label: t('payoutInstructionStatusToast.actionLabel'), onClick: onNavigate}}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('payoutInstructionStatusToast.close')}
    />
  );
};

export function showPayoutInstructionStatusToast(
  status: PayoutInstructionStatusToastProps['status'],
  amount: string,
  onNavigate: () => void
): void {
  const isTerminal =
    status === PayoutInstructionStatus.FAILED || status === PayoutInstructionStatus.CANCELLED;
  toast.custom(
    id => (
      <PayoutInstructionStatusToast
        toastId={id}
        status={status}
        amount={amount}
        onNavigate={onNavigate}
      />
    ),
    {
      duration: isTerminal ? 30_000 : 10_000
    }
  );
}
